import { useEffect, useState } from 'react'
import useCustomEndpoint, { VALID_ENDPOINTS } from '@/hooks/useCustomEndpoint'
import { isEmpty } from 'lodash'

export default function useIntagramGallery() {
  const [images, setImages] = useState([
    {
      media_type: 'CAROUSEL_ALBUM',
      media_url: '',
      permalink: '',
    },
    {
      media_type: 'CAROUSEL_ALBUM',
      thumbnail_url: '',
      permalink: '',
    },
  ])
  const { data: allData } = useCustomEndpoint({
    type: VALID_ENDPOINTS.instagramFeed,
    fetchOnMount: true,
  })

  useEffect(() => {
    if (isEmpty(allData?.feed)) {
      setImages([])
    } else {
      setImages(allData?.feed)
    }
  }, [allData])

  return { images }
}
